<template lang="pug">
  .wrap
    nav.sidenav
      ul
        li.item
          check-permission(@click.native='closeSidebar' v-for='item in items' :key='item.label'
            :type='item.permission ? item.permission.type : "*"'
            :can='item.permission ? item.permission.can : "*"'
          )
            router-link(v-if='item.routeName' :to="{ name: item.routeName }" exact)
              icon.icon(:name='item.icon')
              | {{ item.label }}
            .label(v-else)
              icon.icon(:name='item.icon')
              | {{ item.label }}
            ul.nav-section-wrap(v-if='item.subNav')
              check-permission(v-for='subItem in item.subNav' :key='subItem.label'
                :type='subItem.permission ? subItem.permission.type : "*"'
                :can='subItem.permission ? subItem.permission.can : "*"'
              )
                router-link.item( tag="li" :to="{ name: subItem.routeName }" exact)
                  a {{ subItem.label }}

</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters("ui", ["sidenavCollapsed"]),
    screenLessThan1100() {
      return this.$mq.resize && this.$mq.below(1100);
    }
  },
  methods: {
    ...mapMutations("ui", ["toggleSidenav"]),
    closeSidebar() {
      if (this.screenLessThan1100) {
        this.toggleSidenav();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/mixins.scss";

.wrap {
  a {
    color: white;
    text-decoration: none;
  }
}
.nav-section-wrap {
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}

.sidenav {
  letter-spacing: 0.05em;
  font-size: 14px;
  li {
    a,
    .label {
      display: block;
      padding: 15px 15px 15px 15px;
      font-family: "gilroyextrabold";
      font-weight: bold;
      transition: color 0.2s;
      .icon {
        float: left;
        margin-top: 2px;
      }
    }

    /* Remove highlight colour on dashboard item */
    a[href="/brapp/"] {
      background: none !important;
    }

    &.router-link-exact-active,
    &.router-link-active {
      a {
        color: #25c4cd;
      }
      li a {
        color: white;
      }
    }
    ul {
      margin-top: -5px;
    }

    li {
      a {
        padding: 5px 0 5px 45px;
        font-family: "gilroylight", sans-serif;
        text-transform: none;
        font-weight: light;
        font-size: 12px;
        transition: background 0.2s;
        &:hover {
          background: #475669;
        }
      }
    }
  }
}

.icon {
  width: 20px;
  margin-right: 10px;
}
</style>
